module.exports = __webpack_public_path__ + "static/img/title.a6c04f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/title.png
// module id = N4lJ
// module chunks = 0